module.exports = __webpack_public_path__ + "static/media/17230010-2bR0wSgs.b0fc7e55.JPG";